export default __webpack_public_path__ + "../img/issuuAPI.png";